import { wrapLazyRoute } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	return [
		{
			path: "/backoffice/storelistmanagement",
			component: wrapLazyRoute(() => import("ci_bo_ui/StoreListManagementPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "empStoreListManagement",
			},
		},
		{
			path: "/backoffice/bannermanagement/campaigns",
			component: wrapLazyRoute(() => import("ci_bo_ui/CampaignManagementPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "campaignManagement",
			},
			childRoutes: [
				{
					path: "/backoffice/bannermanagement/campaigns/:campaignId",
					component: wrapLazyRoute(() => import("ci_bo_ui/CampaignManagementPage"), {
						usesBootstrap: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						noCustomerNeed: true,
						needsEmployee: true,
						trackingName: "campaignManagement",
					},
				},
			],
		},
		{
			path: "/backoffice/ab-experiments",
			component: wrapLazyRoute(() => import("ci_bo_ui/ABExperimentsPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "abExperiments",
			},
			childRoutes: [
				{
					path: "/backoffice/ab-experiments/:experimentId",
					component: wrapLazyRoute(() => import("ci_bo_ui/ABExperimentsPage"), {
						usesBootstrap: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						noCustomerNeed: true,
						needsEmployee: true,
						trackingName: "abExperiments",
					},
				},
			],
		},
		{
			path: "/backoffice/bannermanagement/creatives",
			component: wrapLazyRoute(() => import("ci_bo_ui/CreativesManagementPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "creativesManagement",
			},
			childRoutes: [
				{
					path: "/backoffice/bannermanagement/creatives/:collectionId",
					component: wrapLazyRoute(() => import("ci_bo_ui/CreativesManagementPage"), {
						usesBootstrap: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						noCustomerNeed: true,
						needsEmployee: true,
						trackingName: "creativesManagement",
					},
				},
			],
		},
	];
};
